import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
Grid,
  TextField,
  InputAdornment,
  useTheme,
} from "@mui/material";
import {
  IconArrowLeft,
  IconHeadset,
  IconFileText,
  IconUsers,
  IconClock,
  IconUsersGroup,
  IconMapPin,
  IconSearch,
  IconChevronRight,
} from "@tabler/icons-react";

const AdminOptions = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const menuItems = [
    { title: "Çağrı", description: "Çağrı işlemleri ile ilgili ayarlamaları gerçekleştirin.", icon: IconHeadset, color: "#4FC3F7", path: "/call-management", disabled: false },
    { title: "Formlar", description: "DTMF Form, Scripter, Kalite Kontrol, Tablolar gibi form elementlerinizi yapılandırın.", icon: IconFileText, color: "#BA68C8", path: "/forms", disabled: false },
    { title: "Kullanıcılar", description: "Kullanıcı işlemleri ile ilgili ayarlamaları bu menüden yapabilirsiniz.", icon: IconUsers, color: "#E57373", path: "/user-management", disabled: false },
    { title: "Statüler", description: "Statü renginin özelleştirilmesi, limitlerin belirlenmesi gibi tanımlamaları gerçekleştirin.", icon: IconClock, color: "#F06292", path: "/statuses", disabled: false },
    { title: "Kuyruklar", description: "Kuyruk işlemleri ile ilgili tanımlamaları bu menüden gerçekleştirebilirsiniz.", icon: IconUsersGroup, color: "#FF8A65", path: "/queue-management", disabled: false },
    { title: "Lokasyonlar", description: "Lokasyon özelliği ile ilgili tanımlamaları bu menüden gerçekleştirebilirsiniz.", icon: IconMapPin, color: "#7986CB", path: "/location-management", disabled: false },
    { title: "Raporlar", description: "Çağrı istatistikleri ve performans raporları.", icon: IconFileText, color: "#F48FB1", path: "/admin/reports", disabled: false },
    { title: "Müşteriler", description: "Müşteri kartları ve arama geçmişi.", icon: IconUsers, color: "#A5D6A7", path: "/admin/customers", disabled: false },
  ];

  const handleCardClick = (path?: string, disabled?: boolean) => {
    if (path && !disabled) navigate(path);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F8F9FB",
        px: "100px", // Sağ-sol boşluk
        py: "24px",
        fontFamily: "'Axiforma', sans-serif",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: "24px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconArrowLeft
            size={24}
            color={theme.palette.text.secondary}
            style={{ cursor: "pointer", marginRight: "16px" }}
            onClick={() => navigate(-1)}
          />
          <Typography variant="body1" color="text.secondary">
            Ana Sayfa&nbsp;&nbsp;&gt;&nbsp;&nbsp;
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: "500", color: theme.palette.text.primary }}
          >
            Sistem Yöneticisi
          </Typography>
        </Box>

        <TextField
          variant="outlined"
          placeholder="Arama"
          size="small"
          sx={{
            width: 280,
            bgcolor: "white",
            "& .MuiOutlinedInput-root": {
              borderRadius: "6px",
              fontSize: "0.9rem",
            },
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#EAECEF" },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconSearch size={20} color={theme.palette.grey[400]} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Menu Cards */}
      <Grid container spacing={2}>
        {menuItems.map((item, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 3, lg: 3 }}>
            <Card
              sx={{
                borderRadius: "3px",
                bgcolor: "white",
                cursor: item.disabled ? "not-allowed" : "pointer",
                opacity: item.disabled ? 0.5 : 1,
                boxShadow: "none",
                border: "1px solid #EFF1F4",
                height: "150px", // Kare yapmak için yükseklik
                width: "250px", // Tam genişlik
                display: "flex",
                flexDirection: "column",
                position: "relative", // İkon için relative positioning
                margin: "4px", // Kartlar arası küçük boşluk
              }}
              onClick={() => handleCardClick(item.path, item.disabled)}
            >

              <CardContent
                sx={{
                  p: 2,
                  textAlign: "left",
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  pt: 2.5, // İkon için üstten boşluk
                  pr: 3, // İkon için sağdan boşluk
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ 
                      fontWeight: 600, 
                      fontSize: "0.95rem",
                      pr: 1, // Ok için küçük boşluk
                      textShadow: "0.5px 0 0 currentColor, -0.5px 0 0 currentColor, 0 0.5px 0 currentColor, 0 -0.5px 0 currentColor",
                      letterSpacing: "0.5px",
                      color: "#1e3a8a", // Koyu lacivert
                    }}
                  >
                    {item.title}
                  </Typography>
                  <IconChevronRight size={14} color={theme.palette.grey[400]} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.8rem",
                    lineHeight: 1.4,
                    mt: "auto",
                    pr: 3, // İkon için sağdan boşluk
                    color: "#4a5568", // Laciverte yakın gri
                    textShadow: "0.2px 0 0 currentColor, -0.2px 0 0 currentColor",
                    letterSpacing: "0.2px",
                  }}
                >
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminOptions;

